import { Injectable } from '@angular/core';
import { HttpService, PaymentgetwayService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class UPIPaymentService {

  constructor(private http: HttpService, private PAYMENT_TYPE: PaymentgetwayService) { }

  makePayment(UPIPAYMENT_INFO: any, TANX_ID: any) {
    const UPIPAYMENT_DATA = UPIPAYMENT_INFO;
    const PAYMENT_TYPE = this.PAYMENT_TYPE?.UPIPAYMENT;
    const body = new URLSearchParams();
    body.set("id", TANX_ID);
    body.set("UPI[virtual_address]", UPIPAYMENT_DATA?.upi_banking_number)
    body.set("UPI[payOption]", PAYMENT_TYPE?.upi_pay_option)
    body.set("category", PAYMENT_TYPE?.upi_payment_type)
    body.set("payment[payment_type]", PAYMENT_TYPE?.upi_payment_type)
    body.set("payment[value][virtual_address]", UPIPAYMENT_DATA?.upi_banking_number)
    body.set("payment[value][payOption]", PAYMENT_TYPE?.upi_pay_option)
    body.set("is_api_payment", 'true')
    return this.http.flightsave('b2c/booking/payment', body);
  }
}
